// extracted by mini-css-extract-plugin
module.exports = {"generateBox":"AIGenerate_generateBox__ArpYL","loadingBreathe":"AIGenerate_loadingBreathe__vZGsT","breathe":"AIGenerate_breathe__ea6Et"};